module.exports = require("@swa-ui/core/src/LoadingDepiction/DepictionBulletItem.module.scss");